<div *ngIf="status != 2024 && item.status != 2024">
  <div *ngIf="status == 'A1'">
    <div class="badge status-badge badge-light-blue" [ngClass]="{'no-border': !withBorder}">
      Appel
    </div>
  </div>

  <div *ngIf="status == 'T'">
    <div class="badge status-badge badge-light-blue" [ngClass]="{'no-border': !withBorder}">
      Ticket
    </div>
  </div>

  <div *ngIf="status == 'SMS'">
    <div class="badge status-badge badge-light-blue" [ngClass]="{'no-border': !withBorder}">
      SMS a été envoyé au client final <span style="color: black;">({{ jrh.callTo }})</span>
    </div>
  </div>

  <div *ngIf="status == 'Email'">
    <div class="badge status-badge badge-light-blue" [ngClass]="{'no-border': !withBorder}">
      Email a été envoyé au éxpediteur <span style="color: black;">({{ jrh.callTo }})</span>
    </div>
  </div>

  <!-- pickup status -->
  <!-- PickUp:
new => En attente <br> d'enlévement (edited)
Assigned => Assigné
Declined => Refusé par chauffeur
Picked Up => Pickup assurée
Pickup terminée => Entrée au centrale (edited)  -->
  <div *ngIf="item && !item.pickUpJob">
    <div class="badge status-badge badge-yellow" [ngClass]="{'no-border': !withBorder}" *ngIf="status == 1">
      En attente <br />
      d'enlévement

      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-relance" *ngIf="status == 29" [ngClass]="{'no-border': !withBorder}">
      Relance
      <div *ngIf="showDateUnderBadge">
        {{ item.relanceDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge status-badge badge-yellow" *ngIf="status == 2 && user === 'Admin'"
      [ngClass]="{'no-border': !withBorder}">
      Assigné
      <div *ngIf="showDateUnderBadge">
        {{ item.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-yellow" *ngIf="status == 2 && user === 'User'"
      [ngClass]="{'no-border': !withBorder}">
      En cours
      <div *ngIf="showDateUnderBadge">
        {{ item.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge status-badge badge-red" *ngIf="status == 4" [ngClass]="{'no-border': !withBorder}">
      Refusé <br />
      par chauffeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge status-badge badge-orange" *ngIf="status == 10" [ngClass]="{'no-border': !withBorder}">
      Pickup assurée
      <div *ngIf="showDateUnderBadge">
        {{ item.pickedUpDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green" *ngIf="status == 6" [ngClass]="{'no-border': !withBorder}">
      Entrée <br />
      au centrale
      <div *ngIf="showDateUnderBadge">
        {{ item.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <!-- <br> -->
    <!-- <span *ngIf="status==6&&item?.centrale?.name">Centrale : {{item?.centrale?.name}}</span> -->
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 14" [ngClass]="{'no-border': !withBorder}">
      Annulée <br />
      par vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 16" [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      définitif <br />
      {{ failureReason }}
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 17" [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      vendeur {{ item.sellerReturnConfirmed && 'done'}}
      <div *ngIf="showDateUnderBadge">
        {{ item.sellerReturnConfirmed ? (item.sellerReturnConfirmedAt | date: "dd/MM/yyyy HH:mm") :
        (item.dateRetourVendeur | date: "dd/MM/yyyy HH:mm")
        }}
      </div>
    </div>

    <div class="shadow-none badge status-badge badge-green" *ngIf="status == 3" [ngClass]="{'no-border': !withBorder}">
      <!-- {{ "NOTIFICATION.STATUS.ACCEPTED" | translate }} -->
      Acceptée par <br> le livreur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 5" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 7" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.DECLINED_LAST_MINUTE" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 8" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.DECLINED_BY_ADMIN" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 9" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.UNSUCCESSFUL" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 13" [ngClass]="{'no-border': !withBorder}">
      Adresse <br />
      manquante
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div>
      <div class="shadow-none badge status-badge badge-red" *ngIf="status == 18" [ngClass]="{'no-border': !withBorder}">
        Retour <br />
        vendeur done
        <div *ngIf="showDateUnderBadge">
          {{ item.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
        </div>
      </div>
    </div>

    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 19"
      [ngClass]="{'no-border': !withBorder}">
      Retour point <br />
      relais
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 20"
      [ngClass]="{'no-border': !withBorder}">
      Transfert <br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-red" *ngIf="status == 28" [ngClass]="{'no-border': !withBorder}">
      Vérif:
      {{ failureReason || item?.failureReason }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.verificationDate || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 21" [ngClass]="{'no-border': !withBorder}">
      Lost
      <div *ngIf="showDateUnderBadge">
        {{ item.lostDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 22" [ngClass]="{'no-border': !withBorder}">
      Transfert <br />
      Annulé
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-green" *ngIf="status == 23" [ngClass]="{'no-border': !withBorder}">
      Échange <br />
      confirmé
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 24"
      [ngClass]="{'no-border': !withBorder}">
      Retour vers <br />
      dépôt - {{ item?.centrale?.name }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-mauve" *ngIf="status == 25" [ngClass]="{'no-border': !withBorder}">
      En dépôt
      <div>{{ item?.centrale?.name }}</div>
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-blue" *ngIf="status == 27" [ngClass]="{'no-border': !withBorder}">
      Transfert retour
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </div>

  <!-- livraison status -->
  <!--
new => En attente <br> de livraison
Assigned => Assigné
Declined => Refusé par chauffeur
Picked up => Livraison en cours
Finished => Commande livrée
Retour au magazin => Retour provisoir <br> { Raison }
Retour difinitif => Retour difinitif
Retour au client => Retour vendeur
Canceled/ Declined by client => Annulée par vendeur
 -->
  <div *ngIf="item && item.pickUpJob">
    <div class="badge status-badge badge-yellow" *ngIf="status == 1 && user == 'Admin'"
      [ngClass]="{'no-border': !withBorder}">
      En attente <br />
      de livraison
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-yellow" *ngIf="status == 2 && user === 'Admin'"
      [ngClass]="{'no-border': !withBorder}">
      Assigné
      <div *ngIf="showDateUnderBadge">
        {{ item.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-yellow" *ngIf="status == 2 && user === 'User'"
      [ngClass]="{'no-border': !withBorder}">
      En cours
      <div *ngIf="showDateUnderBadge">
        {{ item.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-red" *ngIf="status == 4" [ngClass]="{'no-border': !withBorder}">
      Refusé par <br />
      chauffeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-relance" *ngIf="status == 29" [ngClass]="{'no-border': !withBorder}">
      Relance
      <div>
        {{failureReason}}
      </div>
      <div *ngIf="showDateUnderBadge">
        {{ item.relanceDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-orange" *ngIf="status == 10" [ngClass]="{'no-border': !withBorder}">
      Livraison <br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green" *ngIf="!item.isExchanged && status == 6 && !item.exchangeStatus"
      [ngClass]="{'no-border': !withBorder}">
      Livrée
      <div *ngIf="showDateUnderBadge">
        {{ item.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green"
      *ngIf="item.isExchanged && status == 6 && item.exchangeStatus && !showDateUnderBadge"
      [ngClass]="{'no-border': !withBorder}">
      Échange <br />
      Livrée
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="status == 28" [ngClass]="{'no-border': !withBorder}">
      Vérif: <div class="text-container">{{ failureReason || item?.failureReason }}</div>
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.verificationDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-orange" *ngIf="status == 15 && user == 'Admin'"
      [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      provisoire
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
      <div class="mt-2">
        {{ failureReason || item?.failureReason }}
        <div *ngIf="(failureReason && reportedTo) || item?.failureReason == 'Livraison reportée'">
          pour le {{ reportedTo || item?.reportedTo | date: "dd/MM/yyyy" }}
        </div>
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 16" [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      définitif <br />
      {{ failureReason }}
      <div *ngIf="item.dateConfirmRetourDefinitifByAdmin">confirmé</div>
      <div *ngIf="showDateUnderBadge && !item.dateConfirmRetourDefinitifByAdmin">
        {{ item.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
      <div *ngIf="showDateUnderBadge && item.dateConfirmRetourDefinitifByAdmin">
        {{ item.dateConfirmRetourDefinitifByAdmin | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 17" [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      vendeur {{ item.sellerReturnConfirmed && 'done'}}
      <div *ngIf="showDateUnderBadge">
        {{ item.sellerReturnConfirmed ? (item.sellerReturnConfirmedAt | date: "dd/MM/yyyy HH:mm") :
        (item.dateRetourVendeur | date: "dd/MM/yyyy HH:mm") }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 14" [ngClass]="{'no-border': !withBorder}">
      Annulée <br />
      par vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-green"
      *ngIf="status == 30 || (showDateUnderBadge && item.status == 6 && item.isExchange)"
      [ngClass]="{'no-border': !withBorder}">
      Échange <br />
      livrée
      <div *ngIf="showDateUnderBadge && item.status == 6 && item.isExchange && item.exchangeStatus == 1">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-mauve"
      *ngIf="status == 31 || (status == 6 && item.isExchange && showDateUnderBadge && item.exchangeStatus == 2)"
      [ngClass]="{'no-border': !withBorder}">
      Échange entrée <br />
      au centrale
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow"
      *ngIf="status == 6 && showDateUnderBadge && item.isExchange && item.exchangeStatus == 3"
      [ngClass]="{'no-border': !withBorder}">
      Transfert échange <br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div
      *ngIf="status == 6 && showDateUnderBadge && item.isExchange && item.exchangeStatus == 3 && item?.destinationCentral?.name ">
      vers {{ item?.destinationCentral?.name }}
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 32"
      [ngClass]="{'no-border': !withBorder}">
      Transfert échange<br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red"
      *ngIf="status == 33 || (showDateUnderBadge && item.exchangeStatus == 4)" [ngClass]="{'no-border': !withBorder}">
      Échange retourné<br />
      définitivement
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red"
      *ngIf="status == 34 || (showDateUnderBadge && item.exchangeStatus == 5)" [ngClass]="{'no-border': !withBorder}">
      Échange retourné<br />
      au vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-green" *ngIf="status == 3" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.ACCEPTED" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 5" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 7" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.DECLINED_LAST_MINUTE" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 8" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.DECLINED_BY_ADMIN" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 9" [ngClass]="{'no-border': !withBorder}">
      {{ "NOTIFICATION.STATUS.UNSUCCESSFUL" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 13" [ngClass]="{'no-border': !withBorder}">
      Adresse <br />
      manquante
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 18" [ngClass]="{'no-border': !withBorder}">
      Retour <br />
      vendeur done
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 19"
      [ngClass]="{'no-border': !withBorder}">
      Retour point <br />
      relais
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 20"
      [ngClass]="{'no-border': !withBorder}">
      Transfert <br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div *ngIf="status == 20">
      vers {{ item?.destinationCentral?.name }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 21" [ngClass]="{'no-border': !withBorder}">
      Lost
      <div *ngIf="showDateUnderBadge">
        {{ item.lostDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-green" *ngIf="status == 23" [ngClass]="{'no-border': !withBorder}">
      Échange <br />
      confirmé
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 24"
      [ngClass]="{'no-border': !withBorder}">
      Retour vers <br />
      dépôt - {{ item?.centrale?.name }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 26"
      [ngClass]="{'no-border': !withBorder}">
      confisqué
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-mauve" *ngIf="status == 25"
      [ngClass]="{'no-border': !withBorder}">
      En dépôt
      <div>{{ item?.centrale?.name }}</div>
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-blue" *ngIf="status == 27" [ngClass]="{'no-border': !withBorder}">
      Transfert retour
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="mt-2" *ngIf="status == 25 && failureReason || item?.failureReason == 'Livraison reportée'">
      <div>
        Livraison reportée <br />
        pour le {{ reportedTo || item?.reportedTo | date: "dd/MM/yyyy" }}
      </div>
    </div>
  </div>
</div>

<!-- status 4 partner -->
<div *ngIf="status4Partner && 0">
  <!-- status des pickup -->
  <!--
New == Assigned == Declined by driver ====> En attente <br> d'enlévement


     -->
  <div *ngIf="item && !item.pickUpJob">
    <div class="badge status-badge badge-yellow" *ngIf="status == 1 || status == 2 || status == 4">
      En attente <br />
      d'enlévement
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-orange" *ngIf="status == 10">
      Pickup assurée <br />
      par INTIGO
      <div *ngIf="showDateUnderBadge">
        {{ item.pickedUpDate || item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green" *ngIf="status == 6">
      Entrée au <br />
      centrale
      <div *ngIf="showDateUnderBadge">
        {{ item.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 14">
      Annulée <br />
      par vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-yellow" *ngIf="status == 5">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </div>

  <!-- status des livraison -->
  <div *ngIf="item && item.pickUpJob">
    <div class="badge status-badge badge-yellow" *ngIf="status == 2 || status == 4">
      En cours <br />
      de livraison
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge status-badge badge-orange" *ngIf="status == 10 || status == 5">
      Livraison <br />
      en cours
      <div *ngIf="showDateUnderBadge">
        {{ item.pickedUpDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green" *ngIf="status == 6">
      Commande <br />
      livrée
      <div *ngIf="showDateUnderBadge">
        {{ item.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 14">
      Annulée <br />
      par vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.updatedAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge status-badge badge-green" *ngIf="status == 15">
      Retour <br />
      provisoire <br />
      {{ failureReason || item?.failureReason }}
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 16">
      Retour <br />
      définitif <br />
      {{ item.failureReason }}
      <span *ngIf="item.dateConfirmRetourDefinitifByAdmin"> Confirmé </span>
      <div *ngIf="showDateUnderBadge && !item.dateConfirmRetourDefinitifByAdmin">
        {{ item.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
      <div *ngIf="showDateUnderBadge && item.dateConfirmRetourDefinitifByAdmin">
        {{ item.dateConfirmRetourDefinitifByAdmin | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge status-badge badge-red" *ngIf="status == 17">
      Retour <br />
      vendeur
      <div *ngIf="showDateUnderBadge">
        {{ item.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </div>
</div>

<!-- Modal edit -->
<div class="modal fade" style="position: absolute; top: 0; width: 100%; z-index: 99999" id="pointRelaisMap"
  tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-center">
            <h5>
              {{ item?.pointRelais?.address }}
              {{ item?.pointRelais?.name }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div *ngIf="item?.pointRelais?.geoLocation?.coordinates?.length">
              <agm-map style="
                  height: 250px;
                  width: 100%;
                  background-color: rgb(229, 227, 223);
                " [latitude]="item.pointRelais.geoLocation.coordinates[0]"
                [longitude]="item.pointRelais.geoLocation.coordinates[1]" [scrollwheel]="false" [zoom]="15">
                <agm-marker style="height: 14px !important" [latitude]="item.pointRelais.geoLocation.coordinates[0]"
                  [longitude]="item.pointRelais.geoLocation.coordinates[1]">
                </agm-marker>
              </agm-map>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" id="closeModal" data-dismiss="modal">
          <i class="flaticon-delete-1"></i> Discard
        </button>
      </div>
    </div>
  </div>
</div>
